<template>
    <div>
        <div v-if="(loadingMatch || loadingResults || loadingMembers) && !match">
            <v-progress-circular size="20" indeterminate color="primary" width="2"></v-progress-circular>
        </div>
        <div v-else-if="match">
            <v-card class="info-card mt-2" outlined>
            <v-card-title class="title">
                <v-icon class="title-icon">mdi-trophy</v-icon>
                {{ match.name }}
            </v-card-title>
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" md="6">
                            <div class="detail">
                                <v-icon small class="detail-icon">mdi-account-multiple</v-icon>
                                <span class="label">{{ $translate("Number of competitors") }}:</span>
                                <span>{{ match.teams.length}}</span>
                            </div>
                            <div class="detail" v-if="referees">
                                <span class="label"><v-icon small class="detail-icon">mdi-whistle</v-icon>{{ $translate("Referees") }}:</span>
                                <div class="referees-container">
                                    <div v-for="ref in referees" :key="ref.id" class="referee-details">
                                        <div class="referee-info">
                                        <div class="referee-name">{{ ref.name }}</div>
                                        <a :href="'mailto:' + ref.mail" v-if="ref.mail" class="icon-link">
                                            <v-icon color="primary">mdi-email-outline</v-icon>
                                        </a>
                                        <a :href="'tel:' + ref.phone" v-if="ref.phone" class="icon-link">
                                            <v-icon color="primary">mdi-phone-outline</v-icon>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="detail">
                                <v-icon small class="detail-icon">mdi-timer</v-icon>
                                <span class="label">{{ $translate("Start time")}}:</span>
                                <span>{{ startTime }}</span>
                            </div>
                            <div class="detail">
                                <v-icon small class="detail-icon">mdi-timer-off</v-icon>
                                <span class="label">  {{ $translate("End time") }}:</span>
                                <span> {{ endTime }}</span>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row v-if="canReportResult">
                        <v-col>
                            <v-btn block class="zoezi-button-thin mb-2 primarytext--text" color="primary" @click="showFinishDialog=true">{{ $translate("Mark as finished") }}</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card class="mt-2">
                <div class="list-header">
                    <div class="header-item"></div>
                    <div class="header-item"><strong>{{ $translate("Competitors") }}</strong></div>
                    <div class="header-item"><strong>{{ $translate("Rank") }}</strong></div>
                    <div class="header-item"><strong>{{ $translate("Result") }}</strong></div>
                    <div v-if="canReportResult" class="header-item"></div>
                </div>

                <div class="list-content">
                    <div v-for="team, index in computedTeams" :key="team.id" class="list-row">
                            <v-avatar class="row-item" :size="40">
                                <img :src="'/api/memberapi/image/member/get?size=50x50&id=' + team.user_id" class="user-image" v-if="team.user_id" />
                                <img :src="'/api/public/image/get?size=50x50&type=team&id=' + team.id" class="user-image" v-else />
                            </v-avatar>
                        <div class="row-item">{{ team.name }}</div>
                        <div class="row-item">{{ index + 1 }}</div>
                        <div class="row-item">{{ team.formattedResult || '-' }}</div>
                        <div v-if="canReportResult" class="row-item">
                            <div v-if="!team.formattedResult">
                                <v-btn small rounded fab color="primary" @click="addResult(team)"><v-icon>mdi-plus</v-icon></v-btn>
                            </div>
                            <div v-else>
                                <v-btn small rounded fab color="secondary" @click="addResult(team)"><v-icon>mdi-pencil</v-icon></v-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card>
            <TeamsportEventDialog
                v-model="showEventDialog"
                :match="match"
                :teamId="selectedTeam.id"
                v-if="showEventDialog"
                oneMatch
            ></TeamsportEventDialog>
            <TeamsportSetResultDialog
                v-model="showFinishDialog"
                :match="match"
                :teams="computedTeams"
                v-if="showFinishDialog"
                oneMatch
            ></TeamsportSetResultDialog>
        </div>
        <div v-else>
            <v-alert type="info">{{ $translate("No match found") }}</v-alert>
        </div>
        
    </div>
</template>
  
<script>
import TeamsportEventDialog from './TeamsportEventDialog.vue';
import TeamsportSetResultDialog from './TeamsportSetResultDialog.vue';
export default {
    name: 'zoezi-teamsport-one-match',

    components: {
        TeamsportEventDialog,
        TeamsportSetResultDialog,
    },

    props: {
        registration: {
            type: Object,
            default: () => ({}),
        },
        referee: {
            type: Boolean,
            default: false,
        },
        matchId: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            loadingMatch: false,
            loadingResults: false,
            loadingMembers: false,
            match: null,
            showEventDialog: false,
            unsubscribe: [],
            selectedTeam: null,
            showFinishDialog: false,
            invalidResults: [],
            members: [],
        };
    },

    watch: {
        match(){
            this.getMembersInMatch();
        }
    },

    mounted() {
        this.getOneMatch();
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsportmatch', callback: (_, event) => {
            if (this.match && event.data.find(x => x.id == this.match.id)) {
                this.getOneMatch();
            }
        }}))
        this.getInvalidResults();
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsportresultinvalidtype', callback: () => {
                this.getInvalidResults();
        }}))
        this.unsubscribe.push(this.$api.subscribe({type: 'settings:teamsportsettings', callback: () => {
            this.fetchTeamsportSettings();
        }}));
        this.fetchTeamsportSettings();
    },

    computed: {
        computedTeams() {
            if (!this.match || !this.invalidResults || !this.match.teams) {
                return [];
            }

            const validResults = [];
            const nullResults = [];
            const invalidResults = [];

            this.match.teams.forEach(team => {
                const result = this.match.result?.find(r => r && r.team_id === team.id);

                if (!result || result.invalid_id !== null) {
                    if (result === null || result === undefined) {
                        nullResults.push(team);
                    } else {
                        invalidResults.push(team);
                    }
                } else {
                    validResults.push(team);
                }
            });

            validResults.sort((a, b) => {
                const resultA = this.match.result?.find(r => r && r.team_id === a.id);
                const resultB = this.match.result?.find(r => r && r.team_id === b.id);

                return this.compareResults(resultA, resultB);
            });

            if (this.match.highest_is_best === true) {
                validResults.reverse();
            }

            const sortedTeams = [...validResults, ...nullResults, ...invalidResults];

            return sortedTeams.map((team) => ({
                ...team,
                formattedResult: this.getFormattedResult(team.id),
                result: this.match.result?.find(r => r && r.team_id === team.id),
                name: this.getName(team.id),
            }));
        },
        startTime() {
            if (!this.match?.activity?.startTime) {
                return null;
            }
            return Date.formatTimeRelative(this.match?.activity?.startTime);
        },
        endTime() {
            if (!this.match?.activity?.endTime) {
                return null;
            }
            return Date.formatTimeRelative(this.match?.activity?.endTime);
        },
        canReportResult() {
            if (!this.$store.state.user) {
                return false;
            }

            if (!this.settings) {
                return false;
            }

            const timeOk = this.match.activity && this.$store.state.now30s < Date.newFull(this.match.activity.endTime).addDays(this.settings.result_report_days);
            if (!this.match?.finished || timeOk) {
                return true;
            }

            if (this.$api.hasPermission('Competition handling')) {
                return true;
            }

            const isReferee = this.match.referees_id && this.match.referees_id.includes(this.$store.state.user.id);
            const refereeCanReport = ['both', 'result'].includes(this.settings.referee_report);
            const teamLeaderCanReport = ['both', 'both_team', 'result'].includes(this.settings.teamleader_report);
            return (isReferee && refereeCanReport) || (this.isTeamLeader && teamLeaderCanReport);
        },
        referees() {
            if (!this.match || !this.members.length) {
                return [];
            }
            return this.match.referees_id.map(id => {
                const user = this.members.find(x => x.id == id);
                return {
                    name: user.name,
                    id: user.id,
                    phone: user.phone,
                    mail: user.mail
                }
            }).sort((a, b) => a.name.localeCompare(b.name));
        },
    },

    methods: {
        fetchTeamsportSettings() {
            this.$api.get('/api/teamsport/settings/get').then(settings => {
                this.settings = settings;
            })
        },
        getMembersInMatch() {
            this.loadingMembers = true;
            return this.$api.get('/api/memberapi/teamsport/get_member_in_match', {match_id: this.match.id}).then(members => {
                this.members = members;
                this.loadingMembers = false;
            })
        },
        compareResults(resultA, resultB) {
            const isInvalidResult = result => result === null || result?.invalid_id !== null;

            const isAInvalid = isInvalidResult(resultA);
            const isBInvalid = isInvalidResult(resultB);

            if (isAInvalid && isBInvalid) return 0;
            if (isAInvalid) return 1;
            if (isBInvalid) return -1;

            if (resultA?.result === null && resultB?.result !== null) return 1;
            if (resultB?.result === null && resultA?.result !== null) return -1;

            // Possible result types to compare: HH.MM.SS, MM.SS, SS.ss, SS.sss, number, pdecimal, integer, decimal
            if (!isNaN(resultA.result) && !isNaN(resultB.result)) {
                return parseFloat(resultA.result) - parseFloat(resultB.result);
            } else {
                return resultA.result.localeCompare(resultB.result);
            }
        },
        getFormattedResult(team_id) {
            let result = this.match.result?.find(r => r.team_id == team_id);
            if (!result) {
                return null;
            }
            if(result.invalid_id) {
                return this.invalidResults.find(x => x.id == result.invalid_id)?.name;
            }
            return result.result;
        },
        getName(team_id) {
            return this.match.teams.find(t => t.id == team_id)?.name;
        },
        getOneMatch() {
            this.loadingMatch = true;
            let url = '';
            let params = {};
            if (this.referee) {
                url = '/api/memberapi/teamsport/referee/division/match/next';
                params = { division_id: this.registration.division.id };
            } else if (this.registration?.id) {
                url = '/api/memberapi/teamsport/match/one_match';
                params = { team_id: this.registration.id };
            } else if (this.matchId) {
                url = '/api/teamsport/match/get';
                params = { id: this.matchId, full: true};
            }
            this.$api.get(url, params).then((match) => {
                this.match = match;
                this.loadingMatch = false;
            });
        },
        addResult(item) {
            this.selectedTeam = item;
            this.showEventDialog = true;
        },
        getInvalidResults() {
            this.loadingResults = true;
            this.$api.get('/api/teamsport/resultinvalid/get').then(response => {
                response.unshift({id: 0, name: 'Valid result'});
                this.invalidResults = response;
                this.loadingResults = false;
            });
        },
        getEvents() {
            this.loading = true;
            this.$api.get('/api/teamsport/event/get', {match_id: this.match.id}).then(response => {
                this.events = response;
                this.loading = false;
            });
        }
    },
    destroyed() {
        this.unsubscribe?.forEach(u => u());
    },
};
</script>

<style scoped>
.list-header, .list-row {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.list-header {
  background-color: #f5f5f5;
}

.header-item, .row-item {
  flex: 1;
  text-align: center;
  padding: 5px;
}

.info-card {
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.title {
  background-color: #f5f5f5;
  color: #333;
  font-size: 1.2em;
  display: flex;
  align-items: center;
}

.title-icon {
  margin-right: 10px;
}

.detail {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
}

.detail-icon {
    margin-right: 10px;
}

.label {
    font-weight: bold;
    margin-right: 10px;
}

.referee-details {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.referee-info {
    display: flex;
    align-items: center;
}

.referee-name, .icon-link {
    display: inline-flex;
    align-items: center;
    margin-right: 0.5rem;
}

.icon-link {
    margin-right: 0.5rem;
}


</style>

